import React from 'react';
import { BrowserRouter, Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { SessionProvider } from './context/SessionContext';
import { GameProvider } from './context/GameContext';
import {
  ROUTES,
  GameLayout,
  LoginPage,
  HomePage,
  QuestionPage,
  ChargePage,
  ProphecyPage,
  SharePage,
} from './pages/OrbGame/OrbGame';
import { applyBackgroundVars } from './utils/assets';

applyBackgroundVars();

/** A launch on the bare domain (`/?otp=…`) goes to /login with its query intact. */
function ToLogin() {
  const { search } = useLocation();
  return <Navigate to={`${ROUTES.login}${search}`} replace />;
}

export default function App() {
  return (
    <BrowserRouter>
      <SessionProvider>
        <GameProvider>
          <Routes>
            <Route index element={<ToLogin />} />
            <Route element={<GameLayout />}>
              <Route path={ROUTES.login} element={<LoginPage />} />
              <Route path={ROUTES.home} element={<HomePage />} />
              <Route path={ROUTES.question} element={<QuestionPage />} />
              <Route path={ROUTES.charge} element={<ChargePage />} />
              <Route path={ROUTES.prophecy} element={<ProphecyPage />} />
              <Route path={ROUTES.share} element={<SharePage />} />
            </Route>
            <Route path="*" element={<Navigate to={ROUTES.home} replace />} />
          </Routes>
        </GameProvider>
      </SessionProvider>
    </BrowserRouter>
  );
}
